module.exports = __webpack_public_path__ + "img/issuelog-icon.f41ee803.svg";